<template>
  <span class="svg-icon-arrow-down">
    <svg :width="width" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M19.1408 13.77C19.4265 14.07 19.4148 14.5448 19.1148 14.8304L13.1148 20.5433C12.8252 20.8191 12.3701 20.8191 12.0805 20.5433L6.08048 14.8304C5.7805 14.5448 5.76886 14.07 6.05449 13.77C6.34012 13.4701 6.81485 13.4584 7.11484 13.7441L12.5977 18.9646L18.0805 13.7441C18.3805 13.4584 18.8552 13.4701 19.1408 13.77Z" :fill="color"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5977 3.25C13.0119 3.25 13.3477 3.58579 13.3477 4V19.84C13.3477 20.2542 13.0119 20.59 12.5977 20.59C12.1835 20.59 11.8477 20.2542 11.8477 19.84V4C11.8477 3.58579 12.1835 3.25 12.5977 3.25Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default: '#E0E3E6' },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
